import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'
import state from './defaultState'

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
